import request from '../../../../../api/request';

const BASE = '/maintainers-portal/financial-portal/settings/collection-fee';

export type CollectionFeeMode = 'capitalPercentage' | 'fixedAmount';

export interface CollectionFeeRuleItem {
  id: number;
  mode: CollectionFeeMode;
  percentage: number | null;
  amount: number | null;
  overdueDays: number;
  validFrom: string;
  isActive: boolean;
  isEditable: boolean;
}

export interface CollectionFeeOverview {
  capitalizes: boolean;
  items: CollectionFeeRuleItem[];
}

export interface CollectionFeePayload {
  mode: CollectionFeeMode;
  percentage?: number;
  amount?: number;
  overdueDays: number;
  validFrom: string;
}

export function getCollectionFees() {
  return request<CollectionFeeOverview>(BASE);
}

export function updateCollectionFeeCapitalizes(capitalizes: boolean) {
  return request<{ capitalizes: boolean }>(`${BASE}/capitalizes`, {
    method: 'put',
    data: { capitalizes },
  });
}

export function createCollectionFeeRule(body: CollectionFeePayload) {
  return request<CollectionFeeRuleItem>(BASE, { method: 'post', data: body });
}

export function updateCollectionFeeRule(id: number, body: CollectionFeePayload) {
  return request<CollectionFeeRuleItem>(`${BASE}/${id}`, {
    method: 'put',
    data: body,
  });
}

export function deleteCollectionFeeRule(id: number) {
  return request<void>(`${BASE}/${id}`, { method: 'delete' });
}
